import { Row, Col, Form, Input, Switch, FormInstance } from "antd";
import { useTranslation } from "react-i18next";
import { ItemsType } from "./itemsType";
import { SetStateAction } from "react";
import { Dispatch } from "react";
import { InputNumber } from "../UI/InputNumberComponent/inputnumber";
import TextArea from "../UI/InputNumberComponent/TextArea";

type props = {
  item: ItemsType | undefined;
  setIsComposed: Dispatch<SetStateAction<boolean>>;
  setIsPacking: Dispatch<SetStateAction<boolean>>;
  isPacking: boolean;
  isComposed: boolean;
  form: FormInstance<any>;
  setIsSaveHide: Dispatch<SetStateAction<boolean>>;
  isEdit: () => boolean;
};
export const Description = ({
  item,
  setIsComposed,
  setIsPacking,
  setIsSaveHide,
  isEdit,
}: props) => {
  const [t] = useTranslation("common");

  return (
    <>
      <Row>
        <Col span={6}>
          <Row>
            <Col span={4}>
              {isEdit() ? (
                <></>
              ) : (
                <Form.Item name="color" label={`${t("color")}`}>
                  <Input
                    type="color"
                    value={item?.color}
                    onChange={() => setIsSaveHide(true)}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Form.Item name="height" label={`${t("height")}`}>
            <InputNumber maxLength={10} onChange={() => setIsSaveHide(true)} />
          </Form.Item>

          <Form.Item name="width" label={`${t("width")}`}>
            <InputNumber maxLength={10} onChange={() => setIsSaveHide(true)} />
          </Form.Item>

          <Form.Item name="depth" label={`${t("depth")}`}>
            <InputNumber maxLength={10} onChange={() => setIsSaveHide(true)} />
          </Form.Item>

          <Form.Item name="weight" label={`${t("weight")}`}>
            <InputNumber maxLength={10} onChange={() => setIsSaveHide(true)} />
          </Form.Item>
        </Col>
        <Col offset={4} span={6}>
          <Form.Item name="description" label={`${t("description")}`}>
            <TextArea maxLength={500} onChange={() => setIsSaveHide(true)} />
          </Form.Item>
        </Col>
        <Col offset={4}>
          {isEdit() ? (
            <Form.Item
              label={`${t("status")}`}
              name="isActive"
              valuePropName={item?.isActive ? "checked" : ""}
              initialValue={item?.isActive}
            >
              <Switch
                data-testid="status-toggle"
                checkedChildren={`${t("active")}`}
                unCheckedChildren={`${t("inactive")}`}
                onChange={() => setIsSaveHide(true)}
              />
            </Form.Item>
          ) : (
            <Form.Item
              label={`${t("status")}`}
              name="isActive"
              valuePropName="checked"
            >
              <Switch
                checkedChildren={`${t("active")}`}
                unCheckedChildren={`${t("inactive")}`}
                defaultChecked
                disabled
                onChange={() => setIsSaveHide(true)}
              />
            </Form.Item>
          )}
          <Form.Item
            name="isComposed"
            label={`${t("composed")}`}
            valuePropName={item?.isComposed ? "checked" : ""}
            initialValue={item?.isComposed}
          >
            <Switch
              data-testid="composed-toggle"
              checkedChildren={`${t("yes")}`}
              onChange={(checked) => setIsComposed(checked)}
              unCheckedChildren={`${t("no")}`}
              disabled={true}
            />
          </Form.Item>
          <Form.Item
            label={`${t("packaging")}`}
            name="isPacking"
            valuePropName={item?.isPacking ? "checked" : ""}
            initialValue={item?.isPacking}
          >
            <Switch
              data-testid="status-toggle"
              checkedChildren={`${t("yes")}`}
              unCheckedChildren={`${t("no")}`}
              onChange={(checked) => setIsPacking(checked)}
              disabled={true}
            />
          </Form.Item>

          {isEdit() ? (
            <Form.Item
              name="isTrackable"
              label={`${t("trackable")}`}
              valuePropName={item?.isTrackable ? "checked" : ""}
              initialValue={item?.isTrackable}
            >
              <Switch
                data-testid="trackable-toggle"
                checkedChildren={`${t("yes")}`}
                unCheckedChildren={`${t("no")}`}
                onChange={() => setIsSaveHide(true)}
              />
            </Form.Item>
          ) : (
            <Form.Item
              name="isTrackable"
              label={`${t("trackable")}`}
              valuePropName="checked"
            >
              <Switch
                checkedChildren={`${t("yes")}`}
                unCheckedChildren={`${t("no")}`}
                defaultChecked
                onChange={() => setIsSaveHide(true)}
              />
            </Form.Item>
          )}

          <Form.Item
            name="isTaxable"
            label={`${t("taxable")}`}
            valuePropName={item?.isTaxable ? "checked" : ""}
            initialValue={item?.isTaxable}
          >
            <Switch
              checkedChildren={`${t("yes")}`}
              unCheckedChildren={`${t("no")}`}
              onChange={() => setIsSaveHide(true)}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
